"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function useFormScrollRef(hasSubmitted, hasBlockFormBuilderPostSubmitMessage) {
  var scrollRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (hasSubmitted) {
      if (!hasBlockFormBuilderPostSubmitMessage) {
        if (typeof (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === 'object' && 'scrollIntoView' in (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
          scrollRef === null || scrollRef === void 0 || scrollRef.current.scrollIntoView();
        }
      }
    }
  }, [hasSubmitted, hasBlockFormBuilderPostSubmitMessage]);
  return scrollRef;
}
var _default = exports.default = useFormScrollRef;